// @ts-nocheck
import * as React from "react";

const QuickOrderLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g fill="currentColor" fillRule="evenodd">
                <path d="M8.9 4.27a2.7 2.7 0 0 1 2.26 0l.201.093a6.498 6.498 0 0 0-.36 2.029l-.711-.332a.73.73 0 0 0-.58 0L4.38 8.54 10 11.15l2.129-.99a6.5 6.5 0 0 0 1.456 1.529L11 12.89v6.72L16.69 17a.48.48 0 0 0 .31-.46v-3.56a6.502 6.502 0 0 0 2-.156v3.716a2.49 2.49 0 0 1-1.47 2.24l-6.4 3a2.7 2.7 0 0 1-2.27 0l-6.4-3A2.49 2.49 0 0 1 1 16.52V9.46a2.39 2.39 0 0 1 .37-1.26l.069-.105L1.52 8l.12-.05a2.6 2.6 0 0 1 .86-.68ZM3 10.1v6.47a.47.47 0 0 0 .3.43L9 19.61v-6.72L3 10.1Z" />
                <path d="m17.5 1.3.225.005a5.201 5.201 0 0 1 4.975 5.2l-.005.22A5.2 5.2 0 1 1 17.5 1.3Zm0 1.4a3.8 3.8 0 0 0-.005 7.6l.195-.005a3.8 3.8 0 0 0 3.61-3.79l-.005-.195A3.8 3.8 0 0 0 17.5 2.7Zm0 1.1a.7.7 0 0 1 .7.7v1.299l1.3.001a.7.7 0 0 1 .694.605l.006.095a.7.7 0 0 1-.7.7h-2a.7.7 0 0 1-.7-.7v-2a.7.7 0 0 1 .7-.7Z" />
            </g>
        </svg>
    );
};

export default React.memo(QuickOrderLine);
